/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./white-block.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./white-block.component";
var styles_WhiteBlockComponent = [i0.styles];
var RenderType_WhiteBlockComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_WhiteBlockComponent, data: {} });
export { RenderType_WhiteBlockComponent as RenderType_WhiteBlockComponent };
export function View_WhiteBlockComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_WhiteBlockComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-white-block", [], [[2, "full-height", null]], null, null, View_WhiteBlockComponent_0, RenderType_WhiteBlockComponent)), i1.ɵdid(1, 114688, null, 0, i2.WhiteBlockComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).classFullHeight; _ck(_v, 0, 0, currVal_0); }); }
var WhiteBlockComponentNgFactory = i1.ɵccf("cc-white-block", i2.WhiteBlockComponent, View_WhiteBlockComponent_Host_0, { fullHeight: "fullHeight" }, {}, ["*"]);
export { WhiteBlockComponentNgFactory as WhiteBlockComponentNgFactory };
